<template>
    <b-modal size="lg" id="defaultModal" hide-footer centered>
        <DeleteCountDown v-if="action.action === 'deleteCountDown'" :action="action"> </DeleteCountDown>

        <EditCountDown v-if="action.action === 'editCountDown'" :action="action"> </EditCountDown>

        <ListNextCountDown v-if="action.action === 'listNextCountDown'" :action="action"> </ListNextCountDown>
    </b-modal>
</template>

<script>
import DeleteCountDown from "../actions/DeleteCountDown";
import EditCountDown from "../actions/EditCountDown";
import ListNextCountDown from "../actions/ListNextCountDown";

export default {
    props: ["action"],
    data() {
        return {};
    },
    components: {
        DeleteCountDown,
        EditCountDown,
        ListNextCountDown
    },
    watch: {},
    mounted() {},
    methods: {},
    computed: {},
    created() {}
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// Modal.vue?b941da40